import {
  ASSISTENTE_RECOMENDACAO_OBTER,
  ASSISTENTE_RECOMENDACAO_SALVAR,
  ASSISTENTE_RECOMENDACAO_LISTAR
} from "../actions/assistente-recomendacao";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const actions = {
  [ASSISTENTE_RECOMENDACAO_OBTER]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v4.assistenteRecomendacao
        .obter(getters.getFornecedorId)
        .then(resp => {
          resolve(resp && resp.data ? resp.data : null);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [ASSISTENTE_RECOMENDACAO_SALVAR]: ({ dispatch, getters }, config) => {
    return new Promise((resolve, reject) => {
      Api.v4.assistenteRecomendacao
        .salvar(getters.getFornecedorId, config)
        .then(resp => {
          resolve(resp && resp.data ? resp.data : null);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [ASSISTENTE_RECOMENDACAO_LISTAR]: ({ dispatch, getters }, params) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedidoAssistenteItem
        .listar(getters.getFornecedorId, params || {})
        .then(resp => {
          resolve(
            resp && resp.data
              ? resp.data
              : { itens: [], total: 0, page: 1, limit: 20 }
          );
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

export default {
  actions
};
